import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { SearchInput } from '@ds/react-components';

const styles = (theme) => ({
  startAdornmentContainer: {
    backgroundColor: theme.palette.xpl.foreground,
    color: theme.palette.xpl.text.action,
  },
  filterIcon: {
    width: '15px',
    height: '15px',
    marginRight: '6px',
  },
  dobGrid: {
    maxWidth: 250,
  },
});

const SsoGroupListFilter = (props) => {
  const { onSubmit } = props;

  const { handleSubmit, register } = useForm({
    defaultValues: {
      search: '',
    },
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  return (
    <form name="searchForm" onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item lg={5} md={6} xs={12}>
          <SearchInput
            name={'search'}
            inputRef={register}
            placeholder={'Search'}
            adornment={
              <SearchInput.SearchIconButton
                type={'submit'}
                variant="secondary"
              />
            }
          />
        </Grid>
      </Grid>
    </form>
  );
};

SsoGroupListFilter.propTypes = {
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(SsoGroupListFilter);
